import { render, staticRenderFns } from "./cpns-info-dialog.vue?vue&type=template&id=861e4db2&scoped=true&"
import script from "./cpns-info-dialog.vue?vue&type=script&lang=js&"
export * from "./cpns-info-dialog.vue?vue&type=script&lang=js&"
import style0 from "./cpns-info-dialog.vue?vue&type=style&index=0&id=861e4db2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861e4db2",
  null
  
)

export default component.exports